<script>
import Vue from 'vue'
import AgGridMethods from '@/Mixins/SigmaClientNew/AgGridMethods'
import AgGridAccountsPayableColumns from '@/Mixins/SigmaClientNew/AgGridAccountsPayableColumns'
import { AgGridVue } from 'ag-grid-vue'

export default Vue.extend({
  name: 'NachaPaymentConfList',

  components: {
    AgGridVue
  },
  mixins: [ AgGridMethods, AgGridAccountsPayableColumns ],

  props: {
    // Name of input field.  Not really necessary, but helpful if we use the form object down the road
    name: {
      required: true,
      type: String
    },

    iteration: {
      required: true,
      type: Number
    },

    width: {
      required: true,
      type: String
    },

    height: {
      required: true,
      type: String
    },

    classes: {
      required: false,
      type: String,
      default: 'ag-theme-balham'
    },

    rowData: {
      required: false
    },

    allowEdit: {
      required: false,
      type: Boolean,
      default: false
    },

    // Ag-grid column defs
    columns: {
      required: false,
      type: Array,
      default: undefined
    },

    // Ag-grid Options
    options: {
      required: false,
      type: Object,
      default: undefined
    },

    allowNotify: {
      required: false,
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      isError: false, // If the input or selected field is incorrect, show an error
      isLoading: false,
      scope: this,
      gridApi: null,
      columnApi: null,
      defaultColDefs: undefined,
      defaultGridOptions: undefined,
      changes: []
    }
  },

  computed: {
    columnDefs () {
      if (this.columns && Array.isArray(this.columns)) {
        return this.columns
      } else {
        return this.defaultColDefs
      }
    },
    gridOptions () {
      return this.options || this.defaultGridOptions
    },

    // Since we are now sending invoices grouped by invoice, this helper updates each row in the group
    updateChildren () {
      if (!this.rowData.length) return false

      this.rowData.forEach((group) => {
        group.attributes.resources.forEach((row) => {
          if (!row.data) return false

          row.data.set('payment_confirmation_number', group.attributes.payment_confirmation_number)
          try {
            row.data.save()
          } catch (error) {
            console.log(error)
            return false
          }
        })
      })

      return true
    },
     // Any groups with at least one transaction selected
    selectedNodes () {
      let aggregatedNodes = []
      this.gridApi.forEachNode((node) => {
        console.log('node', node)
        if (node.selected) {
          aggregatedNodes.push(node)
        }
      })
      return aggregatedNodes
    },

    // Since we are now sending invoices grouped by invoice, this helper makes each group look like a transaction
    simulatedPaymentTransactionData () {
      if (!this.selectedNodes.length) return []

      let transactions = []
      this.selectedNodes.forEach((node) => {
        const transaction = {
          attributes: node.data.attributes
        }
        transactions.push(transaction)
      })

      return transactions
    }
  },

  methods: {
    // Ag-grid
    onGridReady (params) {
      if (!params) return
      this.gridApi = params.api
      this.columnApi = params.columnApi
    },

    onFirstDataRendered (params) {
      if (!params) return
      if (params.api.gridPanel.bodyHeight) params.api.sizeColumnsToFit()
    },

    onCellValueChanged (params) {
      // Ignore if not changed
      if ((params.value && params.oldValue === params.newValue) || !params.data) return
      if (params.column.colId === 'payment_confirmation_number') { this.$emit('updatePaymentNumber', params) }
      if (params.colDef.colId === 'company_email') { this.$emit('updateCCMail', params) }
    },

    updateSelection (gridApi) {
      const api = gridApi || this.gridApi
      if (!api) return
      let selected = []
      api.forEachNode((row) => {
        if (row && row.selected && row.data) {
          if (!row.data.attributes.cc_mail) {
            row.data.attributes['cc_mail'] = row.data.attributes.resources.map((resource) => resource.attributes.company_email).join(', ')
          }
          selected.push(row.data)
        }
      })
      this.$emit('onSelect', selected)
    },

    onChangeVisibleColumns () {
      this.$nextTick(() => {
        this.gridApi.sizeColumnsToFit()
      })
    },

    exportToExcel () {
      this.gridApi.exportDataAsExcel()
    }
  },
  watch: {
    allowNotify () {
      var columnDefs = this.gridApi.getColumnDefs()
      columnDefs.forEach((colDef, index) => {
        if (colDef.colId === 'notify') {
          colDef.hide = this.allowNotify
        }
      })
      this.gridOptions.api.setColumnDefs(columnDefs)
    }
  },
  beforeMount () {
    this.defaultColDefs = [
      // this.nachaVendorSelectColumn,
      this.nachaVendorColumn,
      this.nachaVendorEmailColumn,
      this.nachaCCEmailColumn,
      this.nachaRoutingColumn,
      this.nachaAccountColumn,
      this.apAmountColumn,
      this.nachaPaymentNumberColumn
    ]

    this.defaultGridOptions = {
      singleClickEdit: true,
      undoRedoCellEditing: false,
      enterMovesDown: true,
      enterMovesDownAfterEdit: true,
      rowSelection: 'multiple',
      defaultColDef: {
        resizable: true,
        menuTabs: [],
        suppressSizeToFit: false
      },
      pinnedBottomRowData: [],
      enableRangeSelection: true,
      animateRows: true,
      suppressRowClickSelection: true,

      // Classes and events
      rowClassRules: {
        'ag-error': (params) => params.node.aggData && !this.hasCompleteAchData(params.node.aggData.vendorResource)
      },
      onGridReady: (params) => this.onGridReady(params),
      onFirstDataRendered: (params) => this.onFirstDataRendered(params),
      onCellValueChanged: (params) => this.onCellValueChanged(params),
      onSelectionChanged: (params) => {
        this.updateSelection(params.api)
      }
    }
  }
})
</script>

<template>
<div>
    <!-- v-if="rowData" -->
  <ag-grid-vue
    :name="name"
    :ref="name"
    :class="classes"
    :style="{ width, height }"
    :key="iteration"
    :column-defs="columnDefs"
    :row-data="rowData"
    :grid-options="gridOptions"
  />
</div>
</template>



// WEBPACK FOOTER //
// src/components/SigmaClientNew/NachaPaymentConfList.vue